import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormHelperText,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme, _params, classes) => ({
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

const validationSchema = yup.object({
  name: yup.string().trim().required("Filename is required."),
});

function EditFileDialog({ file, handleUpdateFile, onClose }) {
  const { classes } = useStyles();
  const initialValues = {
    name: file["name"],
  };

  function onSubmit(values, { resetForm }) {
    handleUpdateFile({ id: file["id"], name: values["name"] });
    onClose();
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit,
  });

  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        style: {
          maxWidth: "sm",
        },
      }}>
      <DialogTitle variant="h6" sx={{ display: "flex", alignItems: "center" }}>
        Rename File
      </DialogTitle>
      <DialogContent>
        <form>
          <TextField
            fullWidth
            sx={{ marginTop: 1 }}
            variant="outlined"
            label="Filename"
            name="name"
            error={Boolean(formik.errors.name)}
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          {formik.errors.name && (
            <FormHelperText error sx={{ ml: 1 }}>
              {formik.errors.name}
            </FormHelperText>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          <span className={classes.gradientText}>Cancel</span>
        </Button>
        <Button
          onClick={formik.handleSubmit}
          variant="contained"
          color="primary"
          disabled={formik.isSubmitting || !formik.dirty || !formik.isValid}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditFileDialog;
